<template>
  <!-- Modal 2-->
  <div class="modal fade" id="aptamil1-plus-lichid" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
       aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-4">
              <h3>Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> Lichid 1+</h3>
              <p class="text-center">Formulă de lapte gata <br> de consum, 1L, 1-2 ani</p>
              <img class="img-fluid"
                   src="../../../assets/images/pentru-imunitate/05941209023184_C1C1_s01_100017384.png">
            </div>
            <div class="col-lg-8">
              <div class="scroll-vertical-band">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" id="home1-lichid-tab" data-toggle="tab" href="#home1-lichid"
                       role="tab" aria-controls="home" aria-selected="true">Listă ingrediente</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="profile1-lichid-tab" data-toggle="tab" href="#profile1-lichid"
                       role="tab" aria-controls="profile" aria-selected="false">
                      Ghid de alimentație
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="contact1-lichid-tab" data-toggle="tab" href="#contact1-lichid"
                       role="tab" aria-controls="contact" aria-selected="false">
                      Declarație nutrițională
                    </a>
                  </li>
                </ul>
              </div>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="home1-lichid" role="tabpanel"
                     aria-labelledby="home1-lichid-tab">
                  <p>
                    <strong>Lapte</strong> de vacă degresat, apă, lactoză (din <strong>lapte</strong> de vacă), uleiuri vegetale (ulei de rapiță, ulei de
                    floarea soarelui bogat în acid oleic, ulei de floarea soarelui), galacto-oligozaharide (din <strong>lapte</strong> de
                    vacă), mono- și digliceride ale acizilor grași, fructo-oligozaharide, ulei de pește, fosfat de
                    calciu, corector de aciditate (acid citric), L-ascorbat de sodiu, hidroxid de calciu, citrat de
                    calciu, aromă de <strong>lapte</strong>, lactat feros, D-pantotenat de calciu, DL-alfa-tocoferil acetat, citrat de
                    sodiu, magneziu hidrogen fosfat, hidroxid de potasiu, riboflavină, nicotinamidă, sulfat de zinc,
                    retinil acetat, hidroclorură de piridoxină, mononitrat de tiamină, iodură de potasiu, acid
                    pteroilmonoglutamic, fitomenadionă, D-biotină, colecalciferol, cianocobalamină.
                  </p>
                </div>
                <div class="tab-pane fade" id="profile1-lichid" role="tabpanel" aria-labelledby="profile1-lichid-tab">
                  <ol>
                    <li>Spală-te bine pe mâini și asigură-te că marginea ambalajului este curată.</li>
                    <li>Nu necesită fierbere, produsul fiind deja sterilizat UHT. Produsul este gata preparat pentru consum și se poate utiliza la temperatura camerei sau încălzit la cca 37°C. Verifică pe încheietura mâinii temperatura produsului încălzit. Nu încălzi produsul în cuptorul cu microunde (pericol de supraîncălzire).</li>
                    <li>Agită cutia de Aptamil® NUTRI-BIOTIK™ Lichid 1+ înainte de utilizare.</li>
                    <li>Toarnă cantitatea recomandată în cănuța curată a copilului tău.</li>
                    <li>Produsul trebuie consumat în decurs de maximum două ore din momentul turnării în cănuță.</li>
                    <li>Produsul rămas în cănuță după trecerea perioadei de consum indicate anterior va fi aruncat.</li>
                  </ol>
                </div>
                <div class="tab-pane fade box-shadow" id="contact1-lichid" role="tabpanel"
                     aria-labelledby="contact1-lichid-tab">
                  <div class="row height-row">
                    <div class="col-md-4 col-4 border-table">
                      <span class="span-black pl-0" style="margin-left: 35px;">Declarație nutrițională</span>
                    </div>
                    <div class="col-md-4 col-4 border-table"><span
                        class="span-black">la 100 ml produs</span>
                    </div>
                    <div class="col-md-4 col-4 border-table border-last"><span class="span-black"></span>
                    </div>

                  </div>
                  <valoare></valoare>
                  <grasimi></grasimi>
                  <glucide></glucide>
                  <proteine></proteine>
                  <sare></sare>
                  <vitamine></vitamine>
                  <alte></alte>

                  <p style="color: #A0A0A0; font-size: 12px; padding-left: 15px"> * pot apărea variații naturale în
                    materia primă</p>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Grasimi from "./Table/grasimi";
import Valoare from "./Table/valoare";
import Glucide from "./Table/glucide";
import Proteine from "./Table/proteine";
import Sare from "./Table/sare";
import Vitamine from "./Table/vitamine";
import Alte from "./Table/alte";

export default {
  components: {
    Grasimi,
    Valoare,
    Glucide,
    Proteine,
    Sare,
    Vitamine,
    Alte,
  },
  data() {
    return {}
  },
}
</script>

<style>

</style>
